import React, { Component, Fragment } from 'react'
import Game from './Game'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { withUser } from '../HOC'
import db from '../../helpers/db'
import {
  Button,
  Loader,
  Divider,
  Dimmer,
  Icon,
  Card,
  Popup,
  Message
} from 'semantic-ui-react'

class Games extends Component {
  state = {
    games: [],
    loading: true
  }

  static propTypes = {
    user: PropTypes.object.isRequired
  }

  delete = index => {
    return db.games.delete(this.state.games[index].id).then(() =>
      this.setState(({ games }) => ({
        games: games.filter(game => game.id !== games[index].id)
      }))
    )
  }

  componentDidMount() {
    return db.games
      .find(
        {
          owner: db.users.ref(this.props.user.uid)
        },
        this.formatGame
      )
      .then(games =>
        this.setState({
          games
        })
      )
      .catch(e => console.log(e))
      .then(() => this.setState({ loading: false }))
  }

  async formatGame(game) {
    return {
      loading: false,
      ...game,
      team1: await game.teams[0]
        .get()
        .then(snap => ({ id: snap.id, ...snap.data() })),
      team2: await game.teams[1]
        .get()
        .then(snap => ({ id: snap.id, ...snap.data() }))
    }
  }

  render() {
    const { loading } = this.state
    const games = this.state.games.map((game, i) => {
      return <Game key={i} game={game} delete={() => this.delete(i)} />
    })
    return (
      <Fragment>
        {this.props.user.team ? (
          <Fragment>
            <h1>My Games</h1>
            <Popup
              trigger={
                <Button as={Link} to={`/admin/game`} fluid size="big">
                  <Icon name="plus" />
                  Add Game
                </Button>
              }
              content={<h1>hey</h1>}
              on="click"
              position="bottom center"
            />
            <Divider />
            {loading ? (
              <Dimmer active>
                <Loader>Fetching Games</Loader>
              </Dimmer>
            ) : (
              <Card.Group centered>{games}</Card.Group>
            )}
          </Fragment>
        ) : (
          <Message>
            <Message.Header>No team information</Message.Header>
            <p>Please visit the My Team page to create your team</p>
          </Message>
        )}
      </Fragment>
    )
  }
}

export default withUser(Games)



// WEBPACK FOOTER //
// ./src/components/Admin/Games.jsx